module.exports = __webpack_public_path__ + "img/publicite-mint-retina.829a3b69.png";